/* eslint-disable no-unused-vars */
import { Box, Button, Typography } from "@mui/material";
import { LayoutOnboarding, LoadingBackdrop } from "../../../../components";
import { PAGES_PATH } from "../../../../navigation/params";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import { useUserStatusStore } from "../../../../hooks/redux-hooks/user-status/user-status.store";
import { userActivityLogger } from "../../../../utils/mixpanel";
import { useSentOtp } from "../../../../services/otp-services/otp.services";
import MobileForm from "../../forms/LoginForm/MobileForm";

const AddPhoneNoContainer: React.FC = () => {
  const { setPhoneSignIn } = useUserStatusStore();
  const { handleSendVerifyOtp, sendOtpData, sendOtpLoading, sendOtpError } = useSentOtp();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("testingToken");
  const navigate = useNavigate();
  const handleSendOtp = (loginData: { phone: string }) => {
    const { phone } = loginData;

    if (phone) {
      setPhoneSignIn(phone);
      if (token && process.env.REACT_APP_NODE_ENV !== "production") {
        handleSendVerifyOtp({ phone: loginData.phone, testingToken: token });
      } else {
        handleSendVerifyOtp({ phone: loginData.phone });
      }
      userActivityLogger(MIXPANEL_EVENTS.USER_SIGNUP_ADD_MOBILE_NUMBER,
        { signin_type: "mobile", user_type: "new_user", mobile_signin_enabled: true, mobile_number: loginData.phone });
    }
  };

  useEffect(() => {
    if (sendOtpData) {
      navigate(PAGES_PATH.OTP_VERIFICATION, {
        state: {
          verifyOtpSignUp: true,
          isFromAddPhoneNumber: true,
        } });
    }
  }, [sendOtpData, sendOtpError]);

  return (
    <>
      {sendOtpLoading &&
          <LoadingBackdrop />
      }
      <LayoutOnboarding image="/assets/icons/welcome_screen.jpg">
        <Box className="flex flex-col items-center w-full h-full gap-4">
          <Typography variant="h1" className="!font-bold">Add a Phone Number</Typography>
          <Typography sx={{ mb: 1 }} className="flex !text-base">
           This is how our hospital will reach you
          </Typography>
          <Box className="flex flex-col justify-center items-center gap-8 w-full">
            <Box sx={{ width: "100%" }}>
              <MobileForm handleSendOTP={handleSendOtp} isFromAddPhonePage={true} />
            </Box>
          </Box>
        </Box>
      </LayoutOnboarding>
    </>
  );
};

export default AddPhoneNoContainer;
